import React, { useState } from 'react';
import '../../Styles/DownloadBeta.scss';
import { BarLoader, CircleLoader, RotateLoader } from 'react-spinners';
import { Link, useHistory } from 'react-router-dom';
import mainLogo from '../../assets/icons/Logo.svg';
import PaymentLayout from '../../components/Payment/Payment-layout';
import { downloadService } from '../../services/download.service';
import { useUser } from '../../contexts/userContext';
import TruhuIcon from '../../assets/icons/TruHu_Icon.svg';

const DownloadBeta = () => {
  const {
    state: { hasBetaAccess }
  } = useUser();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const betaVersions = [
    { no: 284, date: 'October 2, 2023' }
//    { no: 281, date: 'September 22, 2023' }
    //{ no: 275, date: 'September 9, 2023' }
    //{ no: 272, date: 'August 18, 2023' }
    //{ no: 266, date: 'June 23, 2023' }
    //{ no: 258, date: 'May 12, 2023' }
    // { no: 242, date: 'May 5, 2023' }
    // { no: 235, date: 'Apr 25, 2023' }
    // {no: 234, date: 'Apr 19, 2023'},
    // {no: 232, date: 'Apr 11, 2023'},
    // {no: 226, date: 'Mar 28, 2023'},
    // {no: 220, date: 'Mar 1, 2023'},
  ];
  // const alphaVersions = [
  //   {no: 206, date: 'Jan 10, 2023'},
  //   {no: 205, date: 'Jan 6, 2023'},
  //   {no: 204, date: 'Jan 5, 2023'},
  //   {no: 203, date: 'Jan 4, 2023'},
  //   {no: 202, date: 'Jan 3, 2023'},
  //   {no: 201, date: 'Dec 29, 2022'},
  // ]
  // const preAlphaVersions = [
  //   {no: 200, date: 'Dec 27, 2022'},
  //   {no: 198, date: 'Dec 23, 2022'},
  //   {no: 197, date: 'Dec 21, 2022'},
  // ]

  const latest = betaVersions.shift();
  const downloadDMG = async (title: string) => {
    setLoading(true);
    try {
      await downloadService.downloadBeta(title);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // if (hasBetaAccess === null) {
  //   return null
  // }
  //
  // if (hasBetaAccess === false) {
  //   history.push('/');
  //   return null
  // }

  return (
    <PaymentLayout>
      <div className="payment__list">
        <div className="payment__header">
          <Link to="/">
            <img src={mainLogo} alt="logo" className="logo__header" />
          </Link>
        </div>
        <h2>Start using TruHu</h2>
        <div className="loader-wrap">
          {loading && (
            <>
              Downloading... <BarLoader width={200} />
            </>
          )}
        </div>
        <div className="flex-sb">
          <img src={TruhuIcon} alt="TruhuIcon" />
          <a
            className="colored-link"
            onClick={() => downloadDMG(`TruHu+Desktop+${latest?.no}.dmg`)}>
            TruHu Desktop Mac {latest?.no}.dmg
          </a>
        </div>
        {betaVersions.map(({ no, date }) => (
          <div key={no} className="flex-sb">
            <a className="colored-link" onClick={() => downloadDMG(`TruHu+Desktop+${no}.dmg`)}>
              Download {no}
            </a>
            <div className="date">{date}</div>
          </div>
        ))}
        {/*{alphaVersions.map(({no, date}) => (*/}
        {/*  <div key={no} className='flex-sb'>*/}
        {/*    <a className='colored-link' onClick={() => downloadDMG(`TruHu+Desktop+${no}.dmg`)} >*/}
        {/*      Download Alpha {no}*/}
        {/*    </a>*/}
        {/*    <div className='date'>{date}</div>*/}
        {/*  </div>*/}
        {/*))}*/}
        {/*{preAlphaVersions.map(({no, date}) => (*/}
        {/*  <div key={no} className='flex-sb'>*/}
        {/*    <a className='colored-link' onClick={() => downloadDMG(`TruHu+Desktop+${no}.dmg`)} >*/}
        {/*      Download Pre-Alpha {no}*/}
        {/*    </a>*/}
        {/*    <div className='date'>{date}</div>*/}
        {/*  </div>*/}
        {/*))}*/}
      </div>
    </PaymentLayout>
  );
};

export default DownloadBeta;
